import {
  DialogTitle,
  styled,
  Typography,
  DialogActions,
  DialogContent,
} from '@material-ui/core';

export const TitleContainer = styled(DialogTitle)(({ theme }) => ({
  borderBottom: `solid 1px ${theme.palette.xpl.stoke}`,
}));

export const ContentContainer = styled(DialogContent)(({ theme }) => ({
  color: theme.palette.xpl.text.secondary,
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '20px',
  marginBottom: '8px',
}));

export const FooterContainer = styled(DialogActions)({
  display: 'flex',
  justifyContent: 'flex-end',
  paddingBottom: '16px',
});

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.xpl.text.primary,
  fontSize: '20px',
  fontWeight: '700',
  lineHeight: '28px',
}));

export const Content = styled(Typography)(({ theme }) => ({
  marginTop: '8px',
  marginBottom: '8px',
}));
